import { useGLTF } from '@react-three/drei'

export default function AlienHead(props) {
  const { nodes, materials } = useGLTF('/models/alien.glb')

  return <group {...props} dispose={null}>
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.Roundcube002.geometry}
      material={materials['Blue Alien']}
      position={[-0.006, 0.949, 0.304]}
      scale={0.534}
    />
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.Sphere001.geometry}
      material={materials['Eyes Black']}
      position={[0.24, 0.714, 0.719]}
      rotation={[1.401, -0.566, -0.511]}
      scale={[-0.143, -0.093, -0.205]}
    />
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.Sphere002.geometry}
      material={materials['Eyes White']}
      position={[0.269, 0.761, 0.799]}
      rotation={[1.489, -0.121, -0.36]}
      scale={[0.066, 0.022, 0.066]}
    />
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.Sphere003.geometry}
      material={materials['Eyes White']}
      position={[0.2, 0.619, 0.806]}
      rotation={[1.895, -0.107, -0.153]}
      scale={[0.03, 0.01, 0.03]}
    />
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.Sphere010.geometry}
      material={materials['Eyes Black']}
      position={[0.24, 0.714, 0.719]}
      rotation={[1.401, -0.566, -0.511]}
      scale={[-0.143, -0.093, -0.205]}
    />
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.Sphere011.geometry}
      material={materials['Eyes White']}
      position={[0.269, 0.761, 0.799]}
      rotation={[1.489, -0.121, -0.36]}
      scale={[0.066, 0.022, 0.066]}
    />
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.Sphere012.geometry}
      material={materials['Eyes White']}
      position={[0.2, 0.619, 0.806]}
      rotation={[1.895, -0.107, -0.153]}
      scale={[0.03, 0.01, 0.03]}
    />
    <mesh
      castShadow
      receiveShadow
      geometry={nodes.NurbsPath002.geometry}
      material={materials['Alien Black']}
      position={[-0.005, 0.395, 0.728]}
      scale={0.662}
    />
  </group>
}

useGLTF.preload('/models/alien.glb')